module.exports = __webpack_public_path__ + "img/steel.f6dfecc8.jpg";